export function readCsrf(): string {
  const m = document.cookie.match(/(^|;)\s*csrftoken=([^;]+)/)
  return m ? (m.pop() as string) : ''
}

export function shuffle<T>(items: readonly T[]): T[] {
  const result = [...items]
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[result[i], result[j]] = [result[j], result[i]]
  }
  return result
}
